"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.post.saved': 'Post saved successfully',
    'socialMediaPlan.post.saveFailed': 'Failed to save post',
    'socialMediaPlan.post.publish': 'Publish Now',
    'socialMediaPlan.post.publishedOn': 'Published on',
    'socialMediaPlan.post.publishFailed': 'Failed to publish on',
    'socialMediaPlan.post.publishError': 'Publishing failed. Try again.',
    'socialMediaPlan.post.duplicated': 'Post duplicated',
    'socialMediaPlan.post.duplicateFailed': 'Failed to duplicate post',
    'socialMediaPlan.post.deleted': 'Post deleted',
    'socialMediaPlan.post.deleteFailed': 'Failed to delete post',
    'socialMediaPlan.post.deleteConfirm': 'Delete this post? This cannot be undone.',
};
